import { FC } from 'react';
import { format } from 'date-fns';
import { dateFormat } from 'constants/formats';
import i18n from 'i18n/config';

const consolidationStatus = {
  COMPLETED: i18n.t('Completed'),
  PENDING: i18n.t('Pending'),
  CANCELED: i18n.t('Canceled'),
  PAUSED: i18n.t('Paused'),
};

const statusStyle = {
  [consolidationStatus.COMPLETED]: 'badge badge-dot text-success',
  [consolidationStatus.PENDING]: 'badge badge-dot text-warning',
  [consolidationStatus.CANCELED]: 'badge badge-dot text-danger',
  [consolidationStatus.PAUSED]: 'badge badge-dot text-gray',
};

export type BeneficiaryVestingPeriod = {
  date: Date;
  vestedUnits: number;
  totalVestedUnits: number;
  status: string;
};

type BeneficiaryCalendarRowProps = {
  period: BeneficiaryVestingPeriod;
  index: number;
};

const BeneficiaryCalendarRow: FC<BeneficiaryCalendarRowProps> = ({
  period,
  index,
}) => (
  <tr>
    <td className="fw-bold">{index}</td>
    <td className="text-left">{format(new Date(period?.date), dateFormat)}</td>
    <td className="text-center">{period.vestedUnits}</td>
    <td className="text-center">{period.totalVestedUnits}</td>
    <td>
      <span className={statusStyle[period.status as keyof typeof statusStyle]}>
        {period.status}
      </span>
    </td>
  </tr>
);

export default BeneficiaryCalendarRow;
